import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import DialogStateMixin from '@/helpers/vue_mixins/v2/DialogStateMixin';
import ButtonLoaderMixin from '@/helpers/vue_mixins/ButtonLoaderMixin';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import ActionButton from '@/components/action_button/Index.vue';
import BaseSubtitle from '@/components/v2/BaseSubtitle';
import Uploader from '@/components/v2/Uploader';
import BaseImagePlaceholder from '@/components/v2/BaseImagePlacelholder';
import BillingPaymentDepositSlipUpload from '@/plugins/graphql/mutations/v2/billing/deposit-slip-upload.gql';
import BillingFullFragment from '@/plugins/graphql/fragments/v2/billing.gql';
import appBasic from '@/plugins/graphql/queries/v2/app-basic.gql';
import { CG_API_BASE } from '@/helpers/constants/app';
import GcashCheckoutCreate from '@/components/v2/ecommerce/GcashCheckoutCreate';
import BilleaseCheckoutCreate from '@/components/v2/ecommerce/BilleaseCheckoutCreate';
/**
 * Billing Payment Gateways Dialog
 * Allow Bank Deposit and Paymaya Payments
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version {0.6.0}
 */
var Payment;
(function (Payment) {
    Payment[Payment["Bank"] = 0] = "Bank";
    Payment[Payment["Paymaya"] = 1] = "Paymaya";
    Payment[Payment["Gcash"] = 2] = "Gcash";
})(Payment || (Payment = {}));
let BillingPaymentDialog = class BillingPaymentDialog extends Mixins(AlertMixin, ButtonLoaderMixin, DialogStateMixin, RouterParamsAppMixin) {
    constructor() {
        super(...arguments);
        this.tab = Payment.Bank;
        this.depositSlips = [];
        this.defaultPaymentMethod = 'default';
        this.selectedMethod = 'default';
        this.availableMethods = [
            {
                name: 'GCash',
                uuid: '1',
                image: require('@/assets/images/gcashtext.png'),
                height: '20',
            },
            {
                name: 'Maya',
                uuid: '2',
                image: require('@/assets/images/maya-text.png'),
                height: '20',
            },
            {
                name: 'Grab Pay',
                uuid: '3',
                image: require('@/assets/images/grabpay.png'),
                height: '20',
            },
            {
                name: 'Visa/Mastercard',
                uuid: '4',
                image: require('@/assets/images/visa-mastercard.png'),
                height: '20',
            },
            {
                name: 'BPI',
                uuid: '5',
                image: require('@/assets/images/bpi.png'),
                height: '30',
            },
            {
                name: 'UnionBank',
                uuid: '6',
                image: require('@/assets/images/unionbank.png'),
                height: '20',
            },
            {
                name: 'RCBC',
                uuid: '7',
                image: require('@/assets/images/rcbc.png'),
                height: '30',
            },
        ];
    }
    get gcashCallbackUrl() {
        return `${CG_API_BASE}/gcash/callback?uuid=${this.billingUuid}&channel=billing&pay_one=${this.payOne}`;
    }
    get billeaseCallbackUrl() {
        return `${CG_API_BASE}/billease/status_update?uuid=${this.billingUuid}&channel=billing&pay_one=${this.payOne}`;
    }
    get currentPath() {
        return window.location.href;
    }
    get bankImageUrl() {
        if (this.tab === Payment.Bank) {
            return require('@/assets/images/bank-white.png');
        }
        return require('@/assets/images/bank-black.png');
    }
    get paymayaImageUrl() {
        return require('@/assets/images/paymaya.png');
    }
    get jbcImageUrl() {
        return require('@/assets/images/jbc.png');
    }
    get visaImageUrl() {
        return require('@/assets/images/visa.png');
    }
    get bpiImageUrl() {
        return require('@/assets/images/bpi.png');
    }
    get sbImageUrl() {
        return require('@/assets/images/security-bank.png');
    }
    get gcashImageUrl() {
        return require('@/assets/images/gcash.png');
    }
    get billeaseImageUrl() {
        return require('@/assets/images/billease.png');
    }
    get inputImages() {
        return this.depositSlips.map((input) => input.file);
    }
    submit() {
        this.requestOnFlight();
        this.upload()
            .then(() => {
            this.hideDialog();
            this.$emit('upload:success');
            this.successNotification('Success');
        })
            .catch((err) => {
            this.errorNotification(err.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    async upload() {
        const appUuid = this.appUUID;
        const billingUUID = this.billingUuid;
        return this.$apollo.mutate({
            mutation: BillingPaymentDepositSlipUpload,
            variables: {
                input: {
                    billingUuid: this.billingUuid,
                    depositSlips: this.inputImages,
                    payOne: this.payOne,
                },
            },
            update(cache, { data }) {
                const { billing } = data.uploadBillingDepositSlips;
                billing.uuid = billingUUID;
                cache.writeFragment({
                    id: billingUUID,
                    fragment: BillingFullFragment,
                    fragmentName: 'Billing',
                    data: billing,
                });
            },
            refetchQueries: [
                {
                    query: appBasic,
                    variables: {
                        appUuid,
                    },
                },
            ],
        });
    }
};
__decorate([
    Prop({ type: String, required: true })
], BillingPaymentDialog.prototype, "billingUuid", void 0);
__decorate([
    Prop({ type: Boolean, required: true })
], BillingPaymentDialog.prototype, "payOne", void 0);
BillingPaymentDialog = __decorate([
    Component({
        components: {
            ActionButton,
            BaseSubtitle,
            BaseImagePlaceholder,
            Uploader,
            GcashCheckoutCreate,
            BilleaseCheckoutCreate,
        },
    })
], BillingPaymentDialog);
export default BillingPaymentDialog;
